import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=3e4a41b3&"
import script from "./Recipes.vue?vue&type=script&lang=js&"
export * from "./Recipes.vue?vue&type=script&lang=js&"
import style0 from "./Recipes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports